{
  "runs": {
    "title": "Runs",
    "description": "Every agent run with its prompt, reasoning, tool calls, tokens and cost.",
    "detailTitle": "Run",
    "backToList": "All runs",
    "openPage": "Open as page",
    "refresh": "Refresh",
    "autoRefresh": "Live",
    "search": "Search prompts and output…",
    "unknownAgent": "Unknown agent",
    "cancel": "Cancel run",
    "cancelRequested": "Cancelling the run…",
    "failedTitle": "The run failed",
    "noOutput": "No output.",
    "noPrompt": "No prompt.",
    "tokensSplit": "{{input}} in · {{output}} out",
    "cacheSplit": "cache {{read}} read · {{write}} written",
    "stepsAndTools": "{{steps}} steps · {{tools}} tool calls",
    "tokenCount_one": "{{count}} token",
    "tokenCount_other": "{{count}} tokens",
    "columns": {
      "status": "Status",
      "run": "Agent & prompt",
      "agent": "Agent",
      "source": "Source",
      "model": "Model",
      "tokens": "Tokens",
      "cost": "Cost",
      "tools": "Tool calls",
      "duration": "Duration",
      "started": "Started"
    },
    "filters": {
      "allAgents": "All agents",
      "allSources": "All sources",
      "allStatuses": "All statuses",
      "from": "From date",
      "to": "To date",
      "clear": "Clear filters"
    },
    "empty": {
      "title": "No runs yet",
      "description": "Runs appear here as soon as an agent answers in chat, an automation, the API or the playground."
    },
    "emptyFiltered": {
      "title": "No runs match these filters",
      "description": "Try another date range or clear the filters."
    },
    "status": {
      "running": "Running",
      "connecting": "Connecting",
      "completed": "Completed",
      "failed": "Failed",
      "cancelled": "Cancelled",
      "waiting": "Waiting",
      "paused": "Paused"
    },
    "source": {
      "chat": "Chat",
      "playground": "Playground",
      "api": "API",
      "endpoint": "Chat endpoint",
      "automation": "Automation",
      "automation_hook": "Automation hook",
      "schedule": "Schedule",
      "workplace": "Workplace",
      "task": "Task",
      "eval": "Evaluation",
      "connector": "Connector"
    },
    "live": {
      "title": "Running",
      "working": "Working…",
      "reconnecting": "Reconnecting to the live stream…"
    },
    "fields": {
      "model": "Model",
      "tokens": "Tokens",
      "cost": "Cost",
      "duration": "Duration",
      "prompt": "Prompt",
      "reasoning": "Reasoning",
      "toolCalls_one": "{{count}} tool call",
      "toolCalls_other": "{{count}} tool calls",
      "output": "Output",
      "details": "Details",
      "agent": "Agent",
      "source": "Source",
      "user": "User",
      "started": "Started",
      "completed": "Finished",
      "runId": "Run ID",
      "context": "Conversation",
      "metadata": "metadata"
    },
    "tools": {
      "arguments": "arguments",
      "result": "result",
      "error": "error",
      "running": "Running…",
      "noResult": "No result."
    },
    "cancelledTitle": "The run was cancelled",
    "cancelledDescription": "It stopped before finishing; anything produced so far is kept."
  },
  "monitor": {
    "title": "Live monitor",
    "description": "Everything that is running right now: agent runs, chat turns and team rooms. Stop single items or pull the emergency brake.",
    "updated": "Updated",
    "since": "Since",
    "stale": "No heartbeat",
    "staleHint": "The node running this run has not reported in a while and probably stopped. Cancelling marks it as cancelled.",
    "untitledChat": "Untitled chat",
    "roomPaused": "Paused",
    "thinking": "Thinking",
    "activeRuns_one": "{{count}} running",
    "activeRuns_other": "{{count}} running",
    "scope": {
      "tenant": "This organization",
      "platform": "All organizations"
    },
    "connection": {
      "live": "Live",
      "connecting": "Connecting…",
      "reconnecting": "Reconnecting…",
      "polling": "Polling"
    },
    "health": {
      "dbOk": "Database OK",
      "dbDown": "Database unreachable",
      "nodeRuns_one": "{{count}} run on this node",
      "nodeRuns_other": "{{count}} runs on this node"
    },
    "kpi": {
      "runs": "Running runs",
      "sessions": "Active chats",
      "rooms": "Busy rooms",
      "stale": "Stalled runs",
      "staleHint": "Runs whose node stopped reporting"
    },
    "sections": {
      "runs": "Runs",
      "runsHint": "Click a run to watch its output live.",
      "sessions": "Chat sessions",
      "rooms": "Team rooms"
    },
    "columns": {
      "organization": "Organization",
      "chatSession": "Chat",
      "steps": "Steps",
      "running": "Running for"
    },
    "actions": {
      "watch": "Watch live",
      "openRun": "Open in run log",
      "cancelRun": "Cancel run",
      "cancelSession": "Stop chat",
      "stopRoom": "Stop room"
    },
    "confirm": {
      "runTitle": "Cancel this run?",
      "runDescription": "{{agent}} stops at the next checkpoint. What it produced so far is kept.",
      "sessionTitle": "Stop this chat?",
      "sessionDescription": "Every running turn of “{{title}}” is cancelled. The conversation itself is kept.",
      "roomTitle": "Stop this room?",
      "roomDescription": "All in-flight work in “{{title}}” stops and thinking workers are released. Messages are kept."
    },
    "empty": {
      "runsTitle": "Nothing running",
      "runsDescription": "Runs appear here the moment an agent starts working, and disappear when they finish.",
      "sessions": "No chat is generating an answer right now.",
      "rooms": "No team room is working right now."
    },
    "toast": {
      "runCancelled": "Cancelling the run…",
      "notRunning": "That run had already finished.",
      "sessionCancelled_one": "Cancelling {{count}} running turn…",
      "sessionCancelled_other": "Cancelling {{count}} running turns…",
      "roomStopped": "Room stopped"
    },
    "killAll": {
      "button": "Stop everything",
      "buttonCount_one": "Stop everything ({{count}})",
      "buttonCount_other": "Stop everything ({{count}})",
      "title": "Stop everything in this organization?",
      "titlePlatform": "Stop everything on the platform?",
      "description": "Cancels all {{runs}} running runs and stops {{rooms}} busy rooms in this organization. Use this in an emergency only.",
      "descriptionPlatform": "Throws the cluster-wide kill switch: every running run of every organization is cancelled ({{runs}} now) and {{rooms}} busy rooms are stopped.",
      "confirmWord": "STOP",
      "action": "Stop everything",
      "done": "Kill switch thrown: {{runs}} runs cancelled, {{rooms}} rooms stopped."
    },
    "controller": {
      "title": "Landscape controller",
      "open": "Controller",
      "ready": "Ready",
      "notConfigured": "No monitor model configured",
      "setupHint": "Choose a monitor model in the organization settings to ask questions about live activity and let the controller cancel runs for you.",
      "openSettings": "Open organization settings",
      "intro": "Ask what is running, why something is stuck, or have the controller stop runs, chats or rooms for you.",
      "suggestions": {
        "whatsRunning": "What is running right now?",
        "stale": "Are there stuck runs?",
        "summary": "Summarize the current load"
      },
      "placeholder": "Ask the controller…",
      "send": "Send",
      "stop": "Stop",
      "stopped": "Stopped",
      "thinking": "Thinking…",
      "empty": "No answer.",
      "newConversation": "New conversation",
      "hint": "Enter to send, Shift+Enter for a new line. The controller can cancel runs in your scope."
    }
  },
  "costs": {
    "title": "Costs & usage",
    "description": "Spend, tokens and run volume from recorded agent runs, by agent, model, user and source.",
    "refresh": "Refresh",
    "views": {
      "tenant": "This organization",
      "platform": "Platform"
    },
    "periods": {
      "today": "Today",
      "24h": "Last 24 hours",
      "7d": "Last 7 days",
      "30d": "Last 30 days",
      "90d": "Last 90 days",
      "this_month": "This month",
      "last_month": "Last month",
      "custom": "Custom range"
    },
    "windows": {
      "1h": "Last hour",
      "6h": "Last 6 hours",
      "24h": "Last 24 hours",
      "today": "Today",
      "3d": "Last 3 days",
      "7d": "Last 7 days",
      "14d": "Last 14 days",
      "30d": "Last 30 days",
      "90d": "Last 90 days",
      "365d": "Last 365 days"
    },
    "buckets": {
      "minute": "Per-minute",
      "hour": "Hourly",
      "day": "Daily",
      "week": "Weekly",
      "month": "Monthly"
    },
    "filters": {
      "period": "Period",
      "from": "From date",
      "to": "To date",
      "allAgents": "All agents",
      "allModels": "All models",
      "allSources": "All sources",
      "user": "User: {{name}}",
      "removeUser": "Remove user filter",
      "clear": "Clear filters",
      "pickRange": "Pick a date range",
      "pickRangeHint": "Choose a start and end date (start on or before end) to see costs for a custom range."
    },
    "metrics": {
      "cost": "Cost",
      "tokens": "Tokens",
      "runs": "Runs",
      "inputTokens": "Input tokens",
      "outputTokens": "Output tokens",
      "okRuns": "Succeeded or running",
      "failedRuns": "Failed"
    },
    "chart": {
      "title": {
        "cost": "Spend over time",
        "tokens": "Tokens over time",
        "runs": "Runs over time"
      },
      "description": "{{bucket}} totals in {{timezone}}.",
      "metric": "Metric",
      "bucket": "Period",
      "showTable": "Show as table",
      "zoomInto": "Zoom into {{bucket}}"
    },
    "kpi": {
      "cost": "Spend",
      "avgPerRun": "{{value}} per run",
      "runs": "Runs",
      "failed": "{{count}} failed · {{rate}} error rate",
      "tokens": "Tokens",
      "latency": "Median duration",
      "latencyHint": "p90 {{p90}} · p99 {{p99}}",
      "toolCalls": "Tool calls",
      "toolErrors_one": "{{count}} error",
      "toolErrors_other": "{{count}} errors",
      "agents": "Agents used",
      "users_one": "by {{count}} user",
      "users_other": "by {{count}} users"
    },
    "dimensions": {
      "agent": "By agent",
      "model": "By model",
      "user": "By user",
      "source": "By source"
    },
    "columns": {
      "runs": "Runs",
      "errorRate": "Error rate",
      "tokens": "Tokens",
      "p50": "Median duration",
      "avgCost": "Per run",
      "cost": "Cost",
      "share": "Share",
      "name": "Name"
    },
    "breakdown": {
      "title": "Breakdown",
      "description": "Click a row to filter the whole page by it.",
      "dimension": "Group by"
    },
    "empty": {
      "title": "No runs in this period",
      "description": "Try a longer period or clear the filters."
    },
    "tools": {
      "title": "Tool usage",
      "description": "Tool calls made by the runs in this slice.",
      "tool": "Tool",
      "calls": "Calls",
      "runs": "Runs",
      "errors": "Errors",
      "avg": "Avg duration",
      "p90": "p90",
      "search": "Search tools…",
      "emptyTitle": "No tool calls",
      "emptyDescription": "None of the runs in this period called a tool."
    },
    "budgets": {
      "title": "Budgets",
      "description": "Current spend against each enabled budget policy.",
      "manage": "Manage budgets",
      "none": "No budget policies are enabled."
    },
    "platform": {
      "window": "Window",
      "liveChats": "Live chats",
      "liveChatsHint": "Updated in the last {{minutes}} min",
      "liveRooms": "Live rooms",
      "liveRoomsHint": "Agents working right now",
      "toolCallsHint_one": "{{count}} tool call",
      "toolCallsHint_other": "{{count}} tool calls",
      "chatTurns": "Chat turns",
      "chatFailureRate": "{{rate}} failed ({{count}})",
      "avgDuration": "Avg run duration",
      "avgDurationHint": "Successful runs only",
      "signIns": "Users signed in",
      "sessionsTouched": "Chats: {{chats}} · Rooms: {{rooms}}",
      "chart": {
        "tokens": "Tokens over time",
        "runs": "Runs over time",
        "chat": "Chat turns over time",
        "tools": "Tool calls over time"
      },
      "metrics": {
        "tokens": "Tokens",
        "runs": "Runs",
        "chat": "Chat",
        "tools": "Tools"
      },
      "chatOk": "Chat turns",
      "chatFailed": "Failed chat turns",
      "toolCalls": "Tool calls",
      "drillHint": "Click a column, or a period in the table view, to zoom into it.",
      "chartTimezone": "Times in {{timezone}}.",
      "backToWindow": "Whole window",
      "tenantsTitle": "Organizations",
      "tenantsDescription": "Top organizations by tokens in this window.",
      "organization": "Organization",
      "tokenShare": "Token share",
      "byModel": "Tokens by model",
      "byAgent": "Tokens by agent",
      "topTools": "Top tools",
      "agentMessages_one": "{{count}} agent handoff",
      "agentMessages_other": "{{count}} agent handoffs",
      "noData": "No usage in this window.",
      "noTools": "No tool calls in this window.",
      "definitions": "How these numbers are counted"
    }
  }
}
